import { render, staticRenderFns } from "./ContentModule.vue?vue&type=template&id=1382b3e4&scoped=true"
import script from "./ContentModule.vue?vue&type=script&lang=js"
export * from "./ContentModule.vue?vue&type=script&lang=js"
import style0 from "./ContentModule.vue?vue&type=style&index=0&id=1382b3e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1382b3e4",
  null
  
)

export default component.exports